import { HostFamilyLecComment } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-comment'
import { HostFamilyLecCommentRequest } from '../../../lib/types/models/host-family-lec-comment/host-family-lec-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateHostFamilyLecComment = async (
  data: UpdateInput<HostFamilyLecCommentRequest> & { hostFamilyId: number }
) => {
  const { id, hostFamilyId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.updateHostFamilyLecComment.url, { id, hostFamilyId }))
    .patch<HostFamilyLecComment, Partial<HostFamilyLecCommentRequest>>(rest)
}
